var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoProjectIlls(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 184,
    height: 124,
    viewBox: "0 0 184 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 25.9609C3.35948 57.8287 6.35645 89.891 6.35645 121.803",
    stroke: "#FB7C51",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.35645 121.077C60.4514 118.699 114.862 120.35 168.997 120.35",
    stroke: "#FB7C51",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2212 121.803C33.2212 109.79 31.9654 96.7032 33.2212 84.7728C33.5081 82.0474 44.3042 83.3405 46.0486 83.3206C49.812 83.2779 52.9721 81.0969 53.9144 85.6199C55.3393 92.4595 54.2774 100.383 54.2774 107.402C54.2774 111.765 55.0035 116.107 55.0035 120.35",
    stroke: "#FB7C51",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4297 119.624C72.5654 106.053 72.693 92.3514 73.4785 78.8028C73.9902 69.9761 74.538 61.1873 74.6079 52.3414C74.6197 50.8508 73.3499 44.3766 75.8584 43.7495C81.2968 42.3899 90.4999 41.3635 96.0675 42.8217C100.365 43.9471 97.8423 61.8914 97.8423 64.4023C97.8423 83.0517 97.8423 101.701 97.8423 120.35",
    stroke: "#FB7C51",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M125.433 121.076C125.54 108.204 126.885 95.4505 126.885 82.5936C126.885 79.6963 125.711 76.0589 129.386 76.0589C130.904 76.0589 142.568 75.1687 142.818 76.543C143.529 80.452 142.858 85.0011 142.858 89.0073C142.858 95.2327 142.858 101.458 142.858 107.684C142.858 112.39 142.858 117.096 142.858 121.802",
    stroke: "#FB7C51",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5908 64.4425C41.8264 54.9599 54.3624 45.8768 66.5803 36.3676C80.7438 25.3441 93.9941 13.2103 108.007 2",
    stroke: "#FB7C51",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M108.007 2C110.502 7.80233 112.39 13.8082 114.824 19.6275C116.117 22.7194 116.256 26.2941 117.809 29.2278C119.541 32.4988 119.981 35.8204 121.601 38.9895C123.472 42.6512 124.982 46.447 126.723 50.163C128.386 53.7092 130.885 48.5507 132.209 47.0974C144.988 33.0746 164.019 23.0776 180.614 14.3433",
    stroke: "#FB7C51",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M168.998 14.3434C172.776 14.3434 176.023 13.8475 179.687 12.9316C182.39 12.2557 182.067 13.6981 182.067 16.2796C182.067 20.7189 181.025 24.2739 179.485 28.3808C178.915 29.9023 179.524 31.408 178.437 32.4952",
    stroke: "#FB7C51",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoProjectIlls);
export default __webpack_public_path__ + "static/media/noProjectIlls.e4eed68a77884e0ab96c694d42268b5b.svg";
export { ForwardRef as ReactComponent };